import { useCallback } from "react";

import { cn } from "@/lib/chillnn/cn";

import { RadioGroup, RadioGroupItem } from "@/components/ui/input/radio-group";

type RecurringPurchaseSwitchSectionProps = {
	isStopRecurringProBilling: boolean;
	onUpdateIsStopRecurringProBilling: () => void;
};

export const RecurringPurchaseSwitchSection = ({
	isStopRecurringProBilling,
	onUpdateIsStopRecurringProBilling,
}: RecurringPurchaseSwitchSectionProps) => {
	const currentValue = isStopRecurringProBilling ? "stop" : "continue";

	const handleValueChange = useCallback(
		(value: string) => {
			if (value === "stop" && !isStopRecurringProBilling) {
				onUpdateIsStopRecurringProBilling();
			} else if (value === "continue" && isStopRecurringProBilling) {
				onUpdateIsStopRecurringProBilling();
			}
		},
		[isStopRecurringProBilling, onUpdateIsStopRecurringProBilling],
	);

	return (
		<div className="space-y-6 rounded-md bg-zinc-100 p-4">
			<RadioGroup value={currentValue} onValueChange={handleValueChange} className="space-y-4">
				<label className="flex cursor-pointer items-start space-x-3">
					<RadioGroupItem value="continue" id="purchase-continue" className="mt-1.5" />
					<div className="flex-1 space-y-1">
						<p className={cn("font-medium", !isStopRecurringProBilling && "font-semibold")}>定期購入する</p>
						<p className="text-sm text-zinc-500">
							チケットの有効期限の7日前に、登録したクレジットカードから自動的に料金が引き落とされます。
						</p>
					</div>
				</label>

				<label className="flex cursor-pointer items-start space-x-3">
					<RadioGroupItem value="stop" id="purchase-stop" className="mt-1.5" />
					<div className="flex-1 space-y-1">
						<p className={cn("font-medium", isStopRecurringProBilling && "font-semibold")}>
							定期購入をやめる
						</p>
						<div className="text-sm text-zinc-500">
							<p>チケットの有効期限を過ぎると、手数料タイプが従量課金型へ移行します。</p>
							<p>「定期購入をやめる」を選択して更新すると、次回の自動更新は行われません。</p>
						</div>
					</div>
				</label>
			</RadioGroup>
		</div>
	);
};

RecurringPurchaseSwitchSection.displayName = "RecurringPurchaseSwitchSection";
